const LoaderLine = () => <div className="h-8 w-full rounded bg-gray-300/80" />;

const CommentLoader = () => {
  return (
    <div className="flex w-full animate-pulse flex-col space-y-6">
      <div className="space-y-4">
        <LoaderLine />
        <LoaderLine />
        <LoaderLine />
        <LoaderLine />
      </div>
    </div>
  );
};

export default CommentLoader;
